<template>
    <el-button 
        size="small"
        class="border-0 bg-transparent"
        :disabled="true"
        v-loading.fullscreen.lock="is_loading"
    ></el-button>
</template>

<script>
    import { Button } from 'element-ui'
    export default {
        props:['is_loading'],
        components: {
            [Button.name]: Button,
        },
    }
</script>
